export const errorHandlingMiddleware = (store) => (next) => (action) => {
  try {
    if(action?.error) store.dispatch({type: "error/set", payload: action.error})
    return next(action)
  } catch (error) {
    store.dispatch({type: "error/set", payload: error})
  }
};